import React from 'react';
import { createRoot } from 'react-dom/client';

import '@profgeosoft/go-react-grid-layout/styles';
import '@repo/go-ui/styles';
import 'react-resizable/css/styles.css';
import 'src/packages/assets/styles/index.scss';
import 'src/declarations';
import 'src/configure';
import 'src/app/i18n';

import { App } from 'src/app/App';

import 'src/app/polyfills';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
